<template>
  <Teleport to="body">
    <Transition name="point-outcome">
      <div v-if="visible" class="point-outcome-overlay" @click="$emit('dismiss')">
        <div class="point-outcome-text" :class="outcomeClass">
          Point {{ outcome }}
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
export default {
  name: 'PointOutcomeOverlay',
  props: {
    outcome: {
      type: String,
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['dismiss'],
  computed: {
    outcomeClass() {
      return this.outcome === 'Won' ? 'outcome-won' : 'outcome-lost';
    }
  }
}
</script>

<style scoped>
.point-outcome-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgb(from var(--grey-1000) r g b / 0.85);
  z-index: 1150;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
}

.point-outcome-text {
  font-size: 3rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.outcome-won {
  color: var(--green-300);
}

.outcome-lost {
  color: var(--red-200);
}

.point-outcome-enter-active {
  transition: opacity 0.2s ease-out;
  .point-outcome-text { 
    transition: transform 0.2s ease-out;
    transform: scale(1);
  }
}

.point-outcome-leave-active {
  transition: opacity 0.3s cubic-bezier(0.65, 0, 0.35, 1), transform 0.3s cubic-bezier(0.65, 0, 0.35, 1);
  .point-outcome-text {
    transition: transform 0.3s cubic-bezier(0.65, 0, 0.35, 1);
    transform: scale(1);
  }
}

.point-outcome-enter-from,
.point-outcome-leave-to {
  opacity: 0;
  .point-outcome-text {
    transform: scale(0.85);
    transition: transform 0.3s cubic-bezier(0.65, 0, 0.35, 1);
  }
}
</style>
